import React from 'react';
import styled from 'styled-components';

import QnAHeader from '../QnAHeader/QnAHeader';
import QuestionBock from '../QuestionBlock/QuestionBlock';
import AnswerBlock from '../AnswerBlock/AnswerBlock';

const QnAAllComponent = () => (
  <QnAAllComponentWrapDiv>
    <QnAHeader></QnAHeader>
    <QuestionBock></QuestionBock>
    <AnswerBlock></AnswerBlock>
  </QnAAllComponentWrapDiv>
);

export default QnAAllComponent;

const QnAAllComponentWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 120rem;
  // margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.xlarge};
  margin:${props.theme.spacing.xlarge} auto ${props.theme.spacing.xxlarge} auto;

`,
);
